import {Component, Input, OnInit} from '@angular/core';
import {FieldType} from '@ngx-formly/core';

@Component({
  selector: 'app-formly-creatable-select-field',
  templateUrl: './formly-creatable-select-field.component.html',
})
export class FormlyCreatableSelectFieldComponent extends FieldType implements OnInit {
  @Input() helpertext: string;
  @Input() label: string;
  @Input() name: string;
  @Input() placeholder: string;
  @Input() required?: boolean;
  @Input()
  invalidtext: string;
  public get invalid(): boolean {
    return this.formControl?.touched ? this.formControl.invalid : false;
    // return this.showInvalid;
  }

  constructor() {
    super();
  }

  ngOnInit(): void {
    this.label = this.to.label;
    this.placeholder = this.to.placeholder;
    this.helpertext = this.to.helpertext;
    this.required = this.to.required;
    this.name = this.key.toString();
    this.invalidtext = this.to.invalidtext;
  }

}
